'use client';

import { Suspense } from 'react';
import { SessionProvider } from 'next-auth/react';

// Components
import { Content } from './Content';

const Page = () => (
  <SessionProvider>
    <Suspense>
      <Content />
    </Suspense>
  </SessionProvider>
);

export default Page;
